export * from './DeleteSegmentDesktop';
export * from './DeleteSegmentMobile';
